import { useEffect, useState } from "react";
import { ProductDetailsViewModel } from "../../../viewmodels/products/product/ProductDetailsViewModel";

import { useLocation } from "react-router-dom";

import { connect } from "react-redux";

import * as actions from "../../../store/actions/index";

import { classNames, getLastItem, withRouter } from "../../../shared/utility";

// PrimeReact Components
import { Card } from "primereact/card";
import { ProgressSpinner } from "primereact/progressspinner";

import ProductDetailsForm from "../../../components/forms/products/ProductDetailsForm";
import ProductPriceList from "../../../components/forms/products/ProductPriceList";
import { useForm } from "../../../components/forms/useForm";

const tabs = [
  { name: "Product Details", href: "#" },
  { name: "Price list", href: "#" },
];

const initialFValues = {
  name: "",
  plu: "",
  barcode: "",
  description: "",
  taxable: 1,
  unit_cost: "",
  unit_price: "",
  stock: "",
  low_stock_threshold: "",
  selling_unit_of_measure: "",
  sub_category_arr: { value: -1, label: "" },
  primary_category: "",
  quickbooks_id: "",
  image1: "",
  image2: "",
  priceList: [],
};

function ProductDetails(props) {
  const { logout } = props;

  const [currentTab, setCurrentTab] = useState(0);

  const { pathname } = useLocation();
  const productId = getLastItem(pathname);

  const {
    primaryCategoryOptions,
    getPrimaryCategoriesForDropdown,
    updateProduct,
    createProduct,
    getProduct,
    product,
    loading,
    getUsersForDropdown,
    usersOptions,
    getSubCategoriesByPrimary,
    subCategoryOptions,
    getPriceListForProduct,
    priceList,
    setPriceList,
    deleteProductImage,
  } = ProductDetailsViewModel(logout, productId);
  const isCreate = productId === "create";

  useEffect(() => {
    const init = async () => {
      if (isCreate) {
        await getPrimaryCategoriesForDropdown();
        await getUsersForDropdown();
        setPriceList([]);
      } else {
        await getPriceListForProduct();
        await getPrimaryCategoriesForDropdown();
        await getUsersForDropdown();
        getProduct();
      }
    };
    init();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const { values, setValues, handleInputChange } = useForm(
    initialFValues,
    false
  );

  const handleSubmit = (e) => {
    e.preventDefault();
    if (isCreate) {
      createProduct({ ...values, priceList });
    } else {
      updateProduct({ ...values, priceList });
    }
  };

  const renderComponent = (index) => {
    switch (index) {
      case 0:
        return (
          <div key={0}>
            {loading ? (
              <div className="flex flex-col items-center justify-center py-12">
                <ProgressSpinner 
                  style={{ width: '50px', height: '50px' }} 
                  strokeWidth="4" 
                  fill="transparent" 
                  animationDuration="1s"
                />
                <p className="text-body-2 apollo-body mt-4">Loading product details...</p>
              </div>
            ) : (
              <ProductDetailsForm
                primaryCategoryOptions={primaryCategoryOptions}
                subCategoryOptions={subCategoryOptions}
                getSubCategoriesByPrimary={getSubCategoriesByPrimary}
                product={isCreate ? values : product}
                actionCall={updateProduct}
                usersOptions={usersOptions}
                setValues={setValues}
                values={values}
                handleSubmit={handleSubmit}
                handleInputChange={handleInputChange}
                deleteProductImage={deleteProductImage}
              />
            )}
          </div>
        );

      case 1:
        return (
          <Card key={1} className="apollo-card" style={{ backgroundColor: 'white' }}>
            {loading ? (
              <div className="flex flex-col items-center justify-center py-12">
                <ProgressSpinner 
                  style={{ width: '50px', height: '50px' }} 
                  strokeWidth="4" 
                  fill="transparent" 
                  animationDuration="1s"
                />
                <p className="text-body-2 apollo-body mt-4">Loading price list...</p>
              </div>
            ) : (
              <ProductPriceList
                actionCall={() => updateProduct(values)}
                priceList={priceList}
                setPriceList={setPriceList}
              />
            )}
          </Card>
        );

      default:
        return (
          <Card key={1000} className="apollo-card" style={{ backgroundColor: 'white' }}>
            <div className="flex flex-col items-center justify-center py-12">
              <p className="text-body-1 apollo-body text-gray-500">Could not load page, please try again</p>
            </div>
          </Card>
        );
    }
  };

  return (
    <div className="p-6 bg-gray-50/50 min-h-screen">
      
      {/* Header Card - matching DataManagementTemplate style */}
      <Card className="mb-2 apollo-card" style={{ backgroundColor: 'white' }}>
        <div className="flex flex-col lg:flex-row lg:items-center lg:justify-between gap-6">
          <div>
            <h1 className="text-2xl font-bold text-gray-800 mb-2">
              {isCreate ? "Create New Product" : values.name ?? "N/A"}
            </h1>
            <p className="text-gray-600">
              {isCreate ? "Add a new product to your inventory" : "Update product information and details"}
            </p>
          </div>
        </div>
      </Card>

      <main>
        {/* Tab Navigation */}
          <div className="py-4">
            <div className="sm:hidden">
              <label htmlFor="tabs" className="sr-only">
                Select a tab
              </label>
              <select
                id="tabs"
                name="tabs"
                className="block w-full border-gray-300 rounded-md focus:ring-primary-500 focus:border-primary-500"
                value={currentTab}
                onChange={(e) => setCurrentTab(parseInt(e.target.value))}
              >
                {tabs.map((tab, index) => (
                  <option key={index} value={index}>{tab.name}</option>
                ))}
              </select>
            </div>
            <div className="hidden sm:block">
              <nav
                className="relative z-0 rounded-lg shadow-sm flex divide-x divide-gray-200 border border-gray-200"
                aria-label="Tabs"
              >
                {tabs.map((tab, index) => (
                  <button
                    key={tab.name}
                    className={classNames(
                      index === currentTab
                        ? "text-primary-600 bg-primary-50"
                        : "text-gray-500 hover:text-gray-700 hover:bg-gray-50",
                      index === 0 ? "rounded-l-lg" : "",
                      index === tabs.length - 1 ? "rounded-r-lg" : "",
                      "group relative min-w-0 flex-1 overflow-hidden bg-white py-4 px-6 text-sm font-medium text-center focus:z-10 transition-colors duration-200"
                    )}
                    onClick={() => setCurrentTab(index)}
                  >
                    <span>{tab.name}</span>
                    <span
                      aria-hidden="true"
                      className={classNames(
                        index === currentTab
                          ? "bg-primary-500"
                          : "bg-transparent",
                        "absolute inset-x-0 bottom-0 h-0.5 transition-colors duration-200"
                      )}
                    />
                  </button>
                ))}
              </nav>
            </div>
          </div>

        {/* Tab Content */}
        {tabs.map((item, index) =>
          index === currentTab ? renderComponent(index) : null
        )}
      </main>
    </div>
  );
}

const mapStateToProps = (state) => {
  return {};
};

const mapDispatchToProps = (dispatch) => {
  return {
    logout: () => dispatch(actions.logout()),
  };
};

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(ProductDetails)
);
